import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { label: '恋爱漫画', path: '/category/romance' },
      { label: '奇幻漫画', path: '/category/fantasy' },
      { label: '动作漫画', path: '/category/action' },
      { label: '悬疑漫画', path: '/category/thriller' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '使用指南', path: '/about#guide' },
      { label: '常见问题', path: '/about#faq' },
      { label: '阅读建议', path: '/about#tips' },
      { label: '反馈建议', path: '/about#contact' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌故事', path: '/about#story' },
      { label: '用户口碑', path: '/about#reputation' },
      { label: '联系我们', path: '/about#contact' },
      { label: '加入我们', path: '/about#join' },
    ],
  },
  {
    title: '法律条款',
    links: [
      { label: '用户协议', path: '/about#terms' },
      { label: '隐私政策', path: '/about#privacy' },
      { label: '版权声明', path: '/about#copyright' },
      { label: '免责声明', path: '/about#disclaimer' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6">
        <div className="py-14">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-foreground-800 mb-4 pb-3 border-b border-background-300/60">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-8 pt-8 border-t border-background-200/70">
            <div>
              <span className="font-heading text-5xl font-black text-foreground-200 leading-none block">
                韩漫
              </span>
              <span className="font-heading text-5xl font-black text-foreground-300 leading-none block">
                阅读
              </span>
              <div className="w-10 h-0.5 bg-primary-400 my-3"></div>
              <p className="text-xs text-foreground-400">
                免费韩国漫画在线阅读平台
              </p>
            </div>

            <div className="flex flex-col items-start sm:items-end gap-3">
              <p className="text-xs text-foreground-400">
                &copy; {new Date().getFullYear()} 韩国漫画网. 保留所有权利.
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="#"
                  className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-100 transition-colors"
                  rel="nofollow"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-100 transition-colors"
                  rel="nofollow"
                  aria-label="微信"
                >
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-9 h-9 rounded-full bg-background-200/70 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-100 transition-colors"
                  rel="nofollow"
                  aria-label="QQ"
                >
                  <i className="ri-qq-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}